import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AccountSchemaDataService, AccountSchemaModel } from '../../services/account-schema-data.service';

@Component({
  selector: 'app-account-schema-add-dialog',
  templateUrl: './account-schema-add-dialog.component.html',
  styleUrls: ['./account-schema-add-dialog.component.css'],
})
export class AccountSchemaAddDialogComponent implements OnInit {
  adding = false;
  originalFormValues: any;

  schemaData: AccountSchemaModel = {
    schema: '',
    nazivSheme: '',
  };

  schemaDataEdit: AccountSchemaModel = {
    schema: '',
    nazivSheme: '',
  };

  constructor(
    public schemaDataService: AccountSchemaDataService,
    public dialogRef: MatDialogRef<AccountSchemaAddDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public importingData: { action: string; data?: AccountSchemaModel }
  ) {}

  ngOnInit(): void {
    if (this.importingData?.data) {
      this.schemaDataEdit = { ...this.importingData.data };
      this.originalFormValues = { ...this.schemaDataEdit };
    }
  }

  async addNewSchemaFromDialog() {
    this.adding = true;
    await this.schemaDataService.addSchema(this.schemaData);
    this.adding = false;
    this.dialogRef.close('res');
  }

  editSchemaFromDialog() {
    this.schemaDataService.editSchema(this.schemaDataEdit);
    this.dialogRef.close();
  }

  isFormDirty(): boolean {
    return JSON.stringify(this.originalFormValues) !== JSON.stringify(this.schemaDataEdit);
  }

  isFormValid(): boolean {
    if (this.importingData?.action === 'Add') {
      return !!(this.schemaData.schema && this.schemaData.nazivSheme);
    } else {
      return !!(this.schemaDataEdit.schema && this.schemaDataEdit.nazivSheme);
    }
  }
}
